var ua = navigator.userAgent;
var platform = navigator.platform;
var system = {
    os: {},
    browser: {}
};

var webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/);
var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
var osx = !!ua.match(/\(Macintosh\; Intel /);
var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
var webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/);
var win = /Win\d{2}|Windows/.test(platform);
var wp = ua.match(/Windows Phone ([\d.]+)/);
var touchpad = webos && ua.match(/TouchPad/);
var kindle = ua.match(/Kindle\/([\d.]+)/);
var silk = ua.match(/Silk\/([\d._]+)/);
var blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
var bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
var rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
var playbook = ua.match(/PlayBook/);
var chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);
var firefox = ua.match(/Firefox\/([\d.]+)/);
var firefoxos = ua.match(/\((?:Mobile|Tablet); rv:([\d.]+)\).*Firefox\/[\d.]+/);
var ie = ua.match(/MSIE\s([\d.]+)/) || ua.match(/Trident\/[\d](?=[^\?]+).*rv:([0-9.].)/);
var edge = ua.match(/Edge\/([\d.]+)/);
var webview = !chrome && ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/);
var safari = webview || ua.match(/Version\/([\d.]+)([^S](Safari)|[^M]*(Mobile)[^S]*(Safari))/);
var linux = ua.match(/linux/i);

// #34040: SAW: Support iPadOS
// All MacBooks do not have touch support and have a larger width. 
// iPads have a smaller width (because they use portrait mode for calculating the width)
if (osx && window.matchMedia("(any-pointer: coarse)").matches)
{
    ipad = window.screen.width <= 1024;
    osx = !ipad;
}

// Todo: clean this up with a better OS/browser seperation:
// - discern (more) between multiple browsers on android
// - decide if kindle fire in silk mode is android or not
// - Firefox on Android doesn't specify the Android version
// - possibly devide in os, device and browser hashes

system.os.osx = osx;

if (system.browser.webkit = !!webkit)
{
    system.browser.version = webkit[1];
}

if (win === undefined || win === null)
{
    win = false;
}

system.os.win = win;

if (android)
{
    system.os.win = false;
    system.os.android = true;
    system.os.version = android[2];
}
if (iphone && !ipod)
{
    system.os.win = false;
    system.os.ios = system.os.iphone = true;
    system.os.version = iphone[2].replace(/_/g, '.');
}

if (ipad)
{
    system.os.win = false;
    system.os.ios = system.os.ipad = true;
    if (ipad[2] !== undefined)
    {
        system.os.version = ipad[2].replace(/_/g, '.');
    }
}

if (ipod)
{
    system.os.win = false;
    system.os.ios = system.os.ipod = true;
    system.os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
}

if (wp)
{
    system.os.win = false;
    system.os.wp = true;
    system.os.version = wp[1];
}

if (webos)
{
    system.os.win = false;
    system.os.webos = true;
    system.os.version = webos[2];
}

if (touchpad)
{
    system.os.win = false;
    system.os.touchpad = true;
}

if (blackberry)
{
    system.os.win = false;
    system.os.blackberry = true;
    system.os.version = blackberry[2];
}

if (bb10)
{
    system.os.win = false;
    system.os.bb10 = true;
    system.os.version = bb10[2];
}

if (rimtabletos)
{
    system.os.win = false;
    system.os.rimtabletos = true;
    system.os.version = rimtabletos[2];
}

if (playbook)
{
    system.browser.playbook = true;
}

if (kindle)
{
    system.os.win = false;
    system.os.kindle = true;
    system.os.version = kindle[1];
}

if (silk)
{
    system.browser.silk = true;
    system.browser.version = silk[1];
}

if (!silk && system.os.android && ua.match(/Kindle Fire/))
{
    system.browser.silk = true;
}

if (chrome)
{
    system.browser.chrome = true;
    system.browser.version = chrome[1];
}
if (firefox)
{
    system.browser.firefox = true;
    system.browser.version = firefox[1];
}

if (firefoxos)
{
    system.os.win = false;
    system.os.firefoxos = true;
    system.os.version = firefoxos[1];
}

if (ie)
{
    system.browser.ie = true;
    system.browser.version = ie[1];
}

if (edge)
{
    //edge reports both 'chrome' & 'edge'
    system.browser.chrome = undefined;
    system.browser.edge = true;
    system.browser.version = edge[1];
}

if (safari && (osx || system.os.ios || win))
{
    system.browser.safari = true;
    if (!system.os.ios || safari[1] !== undefined && system.os.version === undefined)
    {
        system.browser.version = safari[1];
    }
}

if (webview)
{
    system.browser.webview = true;
}

//now check for WINDOWS 10
//(Note, Windows 11 will also state 'true' here => if we'd however need to truly distinguish between 10 and 11,
//we'd need to further check for 'user agent client hints': https://learn.microsoft.com/en-us/microsoft-edge/web-platform/how-to-detect-win11)
if (win && ua.match(/Windows NT 10\.([\d.]+)/))
{
    system.os.win10 = true;
}

system.os.tablet = !!(ipad ||
    playbook ||
    (android && !ua.match(/Mobile/)) ||
    (firefox && ua.match(/Tablet/)) ||
    (ie && !ua.match(/Phone/) && ua.match(/Touch/)));
system.os.phone = !!(!system.os.tablet &&
    !system.os.ipod &&
    (android ||
        iphone ||
        webos ||
        blackberry ||
        bb10 ||
        (chrome && ua.match(/Android/)) ||
        (chrome && ua.match(/CriOS\/([\d.]+)/)) ||
        (firefox && ua.match(/Mobile/)) ||
        (ie && ua.match(/Touch/))));

system.os.isMobile = system.os.tablet || system.os.phone;

/*
 * Method getParameterByName / checkIfTrue
 * Both methods are added to SignAnyWhere.aspx already, because we need them before loading webpack modules
 * As we need xyzmo.SystemDection.js for error.html and reject.html as well and do not want to load any other module like xyzmo.Helpers (Too much dependencies already)
 * we simply add them here as well even not required for SignAnyWhere.aspx but for error.html and reject.html
 */
function getParameterByName(name) 
{
    var match = RegExp("[?&]" + name + "=([^&]*)", "i").exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}

function checkIfTrue(value)
{
    if (value !== undefined && value !== null)
    {
        // Boolean
        if (value === true)
        {
            return true;
        }
        // String
        if (typeof value === "string")
        {
            if (value.toLowerCase() === "true" || value.toLowerCase() === "1")
            {
                return true;
            }
        }
        // Any
        if (parseInt(value, 10) > 0)
        {
            return true;
        }
    }
    return false;
}

var mobileParameter = getParameterByName("mobile");
var forcePhone = (mobileParameter !== undefined && mobileParameter !== null) ? true : false;
if (mobileParameter)
{
    system.os.phone = forcePhone;
    system.os.android = forcePhone;
    system.os.tablet = false;
    system.os.win = false;
    system.os.wp = false;
}

if (system.os.phone || !linux)
{
    linux = false;
}
else
{
    linux = true;
}

system.os.linux = linux;
system.os.hasBeenOpenedThroughSawApp = checkIfTrue(getParameterByName("nativeClientApp"));

export default {
        system: system,
        os: system.os,
        browser: system.browser
    };